<template>
	<div class="message">
		<div class="message-title">通知公告</div>
		<div class="list-wrap listwrap1">
			<div class="item"  @mouseover="stopScroll" @mouseout="startScroll">
				<ul ref="scrollList" class="scroll-list" :style="{animationPlayState: scroll ? 'running' : 'paused'}">
					<li v-for="(item, index) in scrollList" :key="index" @click="scrollBtn(item.id)">
						<span class="item-name">{{ item.title }}</span>&nbsp;&nbsp;&nbsp;
						<span class="item-time">{{ item.createdTime }}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		scrollList:{
			type:Array
		}
	},
  data() {
    return {
    	scroll: true, // 控制滚动状态
    };
  },
  methods: {
    stopScroll() {
      this.scroll = false;
    },
    startScroll() {
      this.scroll = true;
    },
	scrollBtn(id){
		this.$emit('scrollBtn',id)
	}
  },
  mounted() {
    this.startScroll(); // 初始状态下开始滚动
  },
};
	
</script>



  
<style lang="less" scoped>
.message {
	margin-bottom: 10px;
}

.marquee_top {transition: all 0.3s}


.message-title {
	width: 10%;
	height: 65px;
	line-height: 65px;
	background: url(../assets/image/bg_bar.jpg) left center no-repeat;
	text-align: center;
	color: #fff;
	font-size: 18px;
	font-weight: bolder;
	float: left;
}

ul{
	margin: 0;
	padding: 0;
	list-style: none;
	animation: scroll 10s linear infinite;
	li{
		cursor: pointer;
	}
}
.list-wrap1 {
	display: inline-block;
}

.list-wrap {
	height: 65px;
	line-height: 65px;
	width: 1000px;
	overflow-y: scroll;

	span {
		color: black;
		font-size: 16px;
	}

	.item-time {
		float: right;
	}

	.item-name {
		padding-left: 20px;
		background: url(../assets/image/bit4.jpg) left center no-repeat;
	}
}

.list-wrap::-webkit-scrollbar {
	display: none;
}

.item {
	padding-left: 30px;
}
@keyframes scroll {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>

